import React from "react";
import { useSelector } from "react-redux";

import HeaderTableAction from "./HeaderTableAction";
import { useConditionModal } from "components/DashboardInfoTableV2/model/use-condition-modal";

import { getTabs } from "store/selectors/tabsSettings";

import { ReactComponent as SettingsIcon } from "static/icons/settings-condition.svg";

const HeaderTableActions = ({
  column: { columnDef, id },
  handleSettingsOpen,
  isExternalWindow,
  handleChangeSidebar,
}) => {
  const onSettingsOpen = () => {
    handleChangeSidebar(true);
    handleSettingsOpen?.(columnDef)
  };
  const currentTabSettings = useSelector(getTabs)?.[1];

  const onShowConditionModal = useConditionModal({
    tableId: 1,
  });

  const handleEditFunction = () => {
    onShowConditionModal({
      columnScheme: currentTabSettings?.columnSchemes?.[columnDef?.accessorKey],
      isEdit: true,
      autoActiveInputs: true,
    });
  };
  
  if (isExternalWindow && !columnDef?.meta?.custom && (columnDef?.meta?.type !== 0 || columnDef?.meta?.type !== 1 || columnDef?.meta?.type !== 2) ) {
    return null
  }

  return id === "select" ? null : (
    <>
      <HeaderTableAction onClick={isExternalWindow ? handleEditFunction : onSettingsOpen}>
        <SettingsIcon />
      </HeaderTableAction>
    </>
  );
};

export default HeaderTableActions;
